<template>
  <div
    id="how-it-works"
    class="w-full border-t border-b bg-sn-gray-100 md:px-16 md:py-10 font-family-portado border-au_gray-200 md:border-0"
  >
    <div class="container">
      <div
        class="flex items-center justify-between px-4 py-3 text-base font-bold md:hidden md:px-6 lg:px-8"
        @click="isOpen = !isOpen"
      >
        {{ tr('pages.sales.buy.howItWorks.title') }}

        <div class="flex-shrink-0 ml-4">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.75 13.44" v-bind:svg-inline="''" :class="['h-4 w-4 transform', isOpen ? 'rotate-0' : '-rotate-90']" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M11.313 12.026L23.334.006l1.414 1.413-12.02 12.021z"/><path d="M.006 1.417L1.42.002l12.021 12.021-1.414 1.415z"/></svg>
        </div>
      </div>

      <div class="hidden pb-6 md:block">
        <p class="font-bold md:text-lg xl:text-2.5xl">
          {{ tr('pages.sales.buy.howItWorks.title') }}
        </p>
      </div>

      <div :class="['w-full flex-col py-6 px-4 md:px-0 md:pt-2 md:pb-0 md:flex-row md:flex md:space-x-12', isOpen ? '' : 'hidden']">
        <div class="flex mb-6 md:w-1/3 md:mb-0">
          <div class="flex-shrink-0">
            <div class="mr-4">
              <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M19.791 14.648a.455.455 0 00.63-.138 4.549 4.549 0 10-7.64 0c.083.13.227.207.381.207v.005a.455.455 0 00.382-.703 3.64 3.64 0 116.11 0 .455.455 0 00.137.629z" fill="#051446"/><path d="M11.537 15.74a.455.455 0 00.147-.627 5.796 5.796 0 119.823.014.455.455 0 00.385.695.455.455 0 00.39-.213 6.7 6.7 0 10-11.372-.016c.133.213.413.279.627.146z" fill="#051446"/><path d="M24.743 18.2l-6.771-.83v-5.503a1.37 1.37 0 10-2.742 0v9.865l-2.69-3.057-.003.002a1.352 1.352 0 00-2.23 1.487l-.004.004 3.63 7.792a4.57 4.57 0 004.14 2.64h2.793a5.483 5.483 0 005.482-5.483v-5.103c0-.924-.688-1.702-1.605-1.814z" fill="#051446"/></svg>
            </div>
          </div>
          <div class="flex-1 pt-1 mt-0.5 md:mt-0 md:pt-0">
            <p class="text-sm leading-snug xl:text-base md:max-w-64">
              {{ tr('pages.sales.buy.howItWorks.step1') }}
            </p>
          </div>
        </div>

        <div class="flex mb-6 md:w-1/3 md:mb-0">
          <div class="flex-shrink-0">
            <div class="mr-4 md:mr-4">
              <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M21.78 9.6H6.9c-.996 0-1.8.804-1.8 1.8v1.98h19.368A6.298 6.298 0 0121.78 9.6zM5.1 16.02v9.18c0 .996.804 1.8 1.8 1.8h22.2c.996 0 1.8-.804 1.8-1.8v-9.18H5.1zM33.3 8.1c0 2.988-2.412 5.4-5.4 5.4a5.393 5.393 0 01-5.4-5.4c0-2.988 2.412-5.4 5.4-5.4 2.988 0 5.4 2.412 5.4 5.4zm-2.1 0l-3.144-3.144-.72.72 1.92 1.908H24.6v1.02h4.668l-1.92 1.908.72.72L31.2 8.1z" fill="#05164D"/></svg>
            </div>
          </div>
          <div class="flex-1 pt-1 mt-0.5 md:mt-0 md:pt-0">
            <p class="text-sm leading-snug xl:text-base md:max-w-64">
              {{ tr('pages.sales.buy.howItWorks.step2') }}
            </p>
          </div>
        </div>

        <div class="flex mb-6 md:w-1/3 md:mb-0">
          <div class="flex-shrink-0">
            <div class="mr-4 md:mr-4">
              <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M27.9 2.7a5.4 5.4 0 100 10.8 5.4 5.4 0 000-10.8zm-.456 8.302l-2.666-2.439 1.121-1.226 1.416 1.294 2.762-3.145 1.248 1.097-3.881 4.419zM7.2 26.347V25.5H3.6v.6a1.2 1.2 0 001.2 1.2h3.353a.956.956 0 01-.953-.953zm21.6 0a.956.956 0 01-.953.953H31.2a1.2 1.2 0 001.2-1.2v-.6h-3.6v.847z" fill="#05164D"/><path d="M21 25.5h7.8V14.328a5.673 5.673 0 01-1.8 0V24.6H9v-12h14.499a6.323 6.323 0 01-1.282-1.8H8.152a.956.956 0 00-.952.953V25.5H21zm7.8.847V25.5H21v.3a.6.6 0 01-.6.6h-4.8a.6.6 0 01-.6-.6v-.3H7.2v.847a.956.956 0 00.953.953h19.694a.956.956 0 00.953-.953z" fill="#05164D"/><path d="M28.8 26.347V25.5H21v.3a.6.6 0 01-.6.6h-4.8a.6.6 0 01-.6-.6v-.3H7.2v.847a.956.956 0 00.953.953h19.694a.956.956 0 00.953-.953zM11.082 19.89l-.481.483 1.255 1.253 1.932-1.013-2.706-.723" fill="#05164D"/><path d="M23.909 15.809c-.101.037-.318.15-.338.16l-2.843 1.49-7.424.217-.725.73 4.228 1.11-4.547 2.383 3.258.002a.453.453 0 00.201-.042l8.581-4.501c.02-.011.235-.125.323-.187.617-.43.996-1.02.843-1.311-.153-.291-.853-.315-1.557-.052z" fill="#05164D"/></svg>
            </div>
          </div>
          <div class="flex-1 pt-1 mt-0.5 md:mt-0 md:pt-0">
            <p class="text-sm leading-snug xl:text-base md:max-w-64">
              {{ tr('pages.sales.buy.howItWorks.step3') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HowItWorks from '~brand-components/base/sale/how-it-works'

export default HowItWorks.extend()
</script>
